import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeLine: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHomeLine"><Path fillRule="evenodd" clipRule="evenodd" d="M21 8.64458L12 1.28094L3 8.64458V21H21V8.64458ZM7 15.5V17H17V15.5H7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeLine;
